//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'MAP',
  data() {
    return {
      defaultJson: {
        "MAP": "平均动脉压",
        "Diastolic Pressure": "舒张压",
        "Systolic Pressure": "收缩压"
      },
      form: {
        sbp: '',
        dbp: '',
      },
      hasScore: false,
      disabled: false,
      res: '...',
    }
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res = form.dbp + (form.sbp - form.dbp) / 3
        self.res = res.toFixed(0)

        self.hasScore = true
        return String(res)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/MAP.vue